import { post } from '../../Utility/apiHelperNew';
import { requestShowLoader, requestHideLoader } from '../Global/action';
import { RECEIVED_REPORT_RUNS, ERROR_RECEIVED } from './type';

export const fetchReportRuns = (search = {}) => async (dispatch) => {
  dispatch(requestShowLoader());
  try {
    const response = await post(
      `${process.env.REACT_APP_BASE_URL}api/reports/search`,
      search
    );

    if (response.status === 200) {
      dispatch({
        type: RECEIVED_REPORT_RUNS,
        payload: response.data,
      });
    }
  } catch (e) {
    dispatch({ type: ERROR_RECEIVED });
  } finally {
    dispatch(requestHideLoader());
  }
};
